import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import NumberFormat from 'react-number-format'
import { H4 } from './Text'

class BuySellChart extends Component {
  constructor (props) {
    super(props);

    this.state = {
      dataLoaded: false
    }
  }

  componentWillMount = () => {
    const { buySell } = this.props;
    this.getWidth(buySell)
  }

  componentWillReceiveProps = (nextProps) => {
    const { buySell } = nextProps;
    this.getWidth(buySell)
  }

  getWidth = (buySell) => {
    if (!buySell) { return }

    const {
      transitionPriceS,
      transitionPrice1,
      transitionPrice2,
      transitionPrice6,
      transitionPrice7,
      transitionPriceE,
    } = buySell

    const totalRange = transitionPriceE - transitionPriceS;

    // bandS - Red
    const bandS = transitionPrice1 - transitionPriceS  //bandS is new
    const bandSPercent = (100 * bandS) / totalRange

    // band1 - Yellow
    const band1 = transitionPrice2 - transitionPrice1  //band1 used to be SellLow
    const band1Percent = (100 * band1) / totalRange

    // band2to5 - Green
    const band2to5 = transitionPrice6 - transitionPrice2
    const band2to5Percent = (100 * band2to5) / totalRange

    // band6 - Yellow
    const band6 = transitionPrice7 - transitionPrice6   // band6 used to be HoldHigh
    const band6Percent = (100 * band6) / totalRange

    // band7 - Red
    const band7 = transitionPriceE - transitionPrice7   // band7 used to be SellHigh
    const band7Percent = (100 * band7) / totalRange

    this.setState({
      dataLoaded: true,
      bandSPercent,
      band1Percent,
      band2to5Percent,
      band6Percent,
      band7Percent,
      buySell
    });

  }

  suggestion = (currentPrice) => {
    let id;
    let name;
    let boxStyle;

    const {
      transitionPriceS,
      transitionPrice1,
      transitionPrice2,
      transitionPrice6,
      transitionPrice7,
      transitionPriceE
    } = this.props.buySell

    if (transitionPriceS <= currentPrice && currentPrice <= transitionPrice1-.01) {
        id = 'sellLow'
        name = 'Sell'
        boxStyle =  'fr fw6 f7 ttu tracked ba br2 pv1 ph2 bg-red pa3 tl'
    } else if (transitionPrice1 <= currentPrice && currentPrice <= transitionPrice2-.01) {
        id = 'watchLow'
        name = 'Watch'
        boxStyle = 'fr fw6 f7 ttu tracked ba br2 pv1 ph2 bg-yellow pa3 tl'
    } else if (transitionPrice2 <= currentPrice && currentPrice <= transitionPrice6) {
        id = 'buy'
        name = 'Buy'
        boxStyle = 'fr fw6 f7 ttu tracked ba br2 pv1 ph2 bg-green pa3 tl'
    } else if (transitionPrice6 <= currentPrice && currentPrice <= transitionPrice7-.01) {
        id = 'watchHigh'
        name = 'Watch'
        boxStyle = 'fr fw6 f7 ttu tracked ba br2 pv1 ph2 bg-gold pa3 tl'
    } else if (transitionPrice7 <= currentPrice && currentPrice <= transitionPriceE) {
        id = 'sellHigh'
        name = ' Sell'
        boxStyle =  'fr fw6 f7 ttu tracked ba br2 pv1 ph2 bg-red pa3 tl'
    } else {
        id = 'sell'
        name = ' Sell'
        boxStyle =  'fr fw6 f7 ttu tracked ba br2 pv1 ph2 bg-red pa3 tl'
    }

    return {
      id,
      name,
      boxStyle
    }
  }

  render () {
    if (this.state.dataLoaded) {

     // let suggestion = this.suggestion(this.props.currentPrice)

      return (
        <div className="br2 cf bg-white shadow-custom pa3 mb3">
          <div className="cf">
            <span className="fl">
              <H4>Investment Plan for {this.props.symbol}</H4>
            </span>
          </div>
          <p className="f6 gray mt2">Hover to see the calculated price ranges for you to buy (green), watch/hold (yellow) or sell (red) based on the<strong> Practical Valuation</strong> of {this.props.symbol}.</p> 
          <p className="f6 gray mt2">If you are satisfied with the <strong> Practical Investment Return</strong> calculated above, these price ranges would form the basis of your <strong> Investment Plan</strong> for {this.props.symbol}. </p>
          
<span data-tip data-for='sellLow' style={{width: `${this.state.bandSPercent}%`}} className="bar-1 dib fl border-box pv3 bg-red relative tc br2 br--left">
</span>
<ReactTooltip id='sellLow' place='top' class='tc'>
  <p className="fw9 mh0 mv1">Sell at:</p>
  <p className="mh0 mv1">
    <NumberFormat value={this.state.buySell.transitionPrice1-.01} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
        &nbsp;and below
  </p>
</ReactTooltip>

<span data-tip data-for='holdLow' style={{width: `${this.state.band1Percent}%`}} className="bar-2 dib fl border-box pv3 bg-yellow relative tc">
</span>
<ReactTooltip id='holdLow' place='top' class='tc'>
  <p className="fw9 mh0 mv1">Watch at:</p>
    <p className="mh0 mv1">
      <NumberFormat value={this.state.buySell.transitionPrice1} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
      &nbsp;-&nbsp;
      <NumberFormat value={this.state.buySell.transitionPrice2-.01} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
    </p>
</ReactTooltip>

<span data-tip data-for='buy' style={{width: `${this.state.band2to5Percent}%`}} className="bar-3 dib fl border-box pv3 bg-green relative tc">
</span>
<ReactTooltip id='buy' place='top' class='tc'>
  <p className="fw9 mh0 mv1">Buy at:</p>
    <p className="mh0 mv1">
      <NumberFormat value={this.state.buySell.transitionPrice2} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
      &nbsp;-&nbsp;
      <NumberFormat value={this.state.buySell.transitionPrice4} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
      &nbsp;-&nbsp;
      <NumberFormat value={this.state.buySell.transitionPrice6-.01} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
    </p>
</ReactTooltip>

<span data-tip data-for='holdHigh' style={{width: `${this.state.band6Percent}%`}} className="bar-3 dib fl border-box pv3 bg-yellow relative tc">
  
</span>
  <ReactTooltip id='holdHigh' place='top' class='tc'>
    <p className="fw9 mh0 mv1">Watch at:</p>
      <p className="mh0 mv1">
        <NumberFormat value={this.state.buySell.transitionPrice6} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
        &nbsp;-&nbsp;
        <NumberFormat value={this.state.buySell.transitionPrice7-.01} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
      </p>
  </ReactTooltip>

<span data-tip data-for='sellHigh' style={{width: `${this.state.band7Percent}%`}} className="bar-3 dib fl border-box pv3 bg-red relative tc br2 br--right">
 
</span>
  <ReactTooltip id='sellHigh' place='top' class='tc'>
    <p className="fw9 mh0 mv1">Sell at:</p>
      <p className="mh0 mv1">
        <NumberFormat value={this.state.buySell.transitionPrice7} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalPrecision={2} />
        &nbsp;and above
      </p>
  </ReactTooltip>
</div>
)
} else {
return (<div></div>)
}
}
}

export default BuySellChart


// WEBPACK FOOTER //
// ./src/components/BuySellChart.js